
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import Branch from "../lib/Branch";

    @Component({})
    export default class ComingSoon extends Vue{
        @Prop()
        public branch: Branch;

        mounted() {
            if (this.branch.hubspotFormId) {
                hbspt.forms.create({
                    portalId: "8492715",
                    formId: this.branch.hubspotFormId,
                    target: "#hubspot-embed-form-container",
                });
            }


        }
        sendEmail() {
            const userMail = this.$store.state.userMail;
            if(this.$store.state.emailRegex.test(userMail)){
                this.$store.dispatch('notifyNewBranch', {slug: this.$store.state.modalPayload.content.slug, email: userMail });
                this.$store.commit('closeModal');
            }else{
                this.$store.commit('throwError', 'cette adresse mail n\'est pas valide');
            }
        }
    }
